import type { ReactNode } from 'react'

import './page-shell.css'

export interface PageShellProps {
    children: ReactNode
    // Optional extra class on the shell — e.g. views without cards that want a
    // flat white surface instead of the pale page background.
    className?: string
}

// Shared page container: centres content to the standard max-width and applies
// the standard vertical rhythm. Mirrors the portal dashboard (the landing view)
// so every sub-app view aligns to the same grid and padding. The outer page
// padding is owned by .portal-shell__main — this only sets width + gap.
export const PageShell = ({ children, className }: PageShellProps) => (
    <div className={className ? `page-shell ${className}` : 'page-shell'}>{children}</div>
)
